import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { LoginRequest, Product, ProductFilter, Project, RegistrationRequest } from 'src/models';
import { environment } from '../../environments/environment';
import { ConfigService } from '../services/config.service';

@Injectable()
export class ProductService{
    constructor(private http: HttpClient, private configService: ConfigService){}

     errorMessage = {success: false, errorMessage: 'An unkown error occurred'};

    Login(request: LoginRequest){
        return new Promise(resolve => {
            this.http.post<LoginRequest>(this.configService.getConfigBaseApiUrl() + 'api/account/login', request).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error))); 
        });         
    }

    Logout(){
        return new Promise(resolve => {
            this.http.post(this.configService.getConfigBaseApiUrl() + 'api/account/logout', {}).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error))); 
        });
    }

    Register(request: RegistrationRequest){
        return new Promise(resolve => {
            this.http.post(this.configService.getConfigBaseApiUrl() + 'api/account/register', request).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error))); 
        });
    }

    ResetPassword(request: LoginRequest){
        return new Promise(resolve => {
            this.http.post<LoginRequest>(this.configService.getConfigBaseApiUrl() + 'api/account/reset', request).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error)));  
        });     
    }

    SavePassword(request: LoginRequest){
        return new Promise(resolve => {
            this.http.post<LoginRequest>(this.configService.getConfigBaseApiUrl() + 'api/account/savePassword', request).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error)));  
        });     
    }

    VerifyAuth() {
        return new Promise(resolve => {
            this.http.post<LoginRequest>(this.configService.getConfigBaseApiUrl() + 'api/account/verify', {}).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error)));  
        });  
    }

    SaveCustomerNo(no: string) {
         let request = new LoginRequest();
         request.customerNo = no;

        return new Promise(resolve => {
            this.http.post<LoginRequest>(this.configService.getConfigBaseApiUrl() + 'api/account/navCustomerNo', request).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error)));  
        });  
    }

    GetProducts(fltrs: ProductFilter){
        return new Promise(resolve => {
            this.http.get(this.configService.getConfigBaseApiUrl() + 'api/products').subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error))); 
        });         
    }

    GetPdf(project: Project){
        return new Promise(resolve => {
            this.http.post(this.configService.getConfigBaseApiUrl() + 'api/reports/pdf', project, {responseType: 'blob'}).subscribe(data => {
                resolve(data);
               }, error => resolve(this.HandleError(error))); 
        }); 
    }

    GetZip(project: Project){
        return new Promise(resolve => {
            this.http.post(this.configService.getConfigBaseApiUrl() + 'api/reports/zip', project, {responseType: 'blob'}).subscribe(data => {
                resolve(data);
               }, error => resolve(this.HandleError(error))); 
        }); 
    }

    SendPdf(project: Project){
        return new Promise(resolve => {
            this.http.post(this.configService.getConfigBaseApiUrl() + 'api/reports/email', project).subscribe(data => {
                resolve(data);
               }, error => resolve(this.HandleError(error))); 
        }); 
    }

    SaveProject(project: Project) {        
        return new Promise(resolve => {
            this.http.post(this.configService.getConfigBaseApiUrl() + 'api/products/save/project', project).subscribe(data => {
                resolve(data);
               }, error => resolve(this.HandleError(error)));    
        }); 
    }

    GetProjects(customerNo){
        return new Promise(resolve => {
            this.http.get(this.configService.getConfigBaseApiUrl() + `api/products/projects/-1/${customerNo}`).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error))); 
        });         
    }

    SearchForQuote(customerNo, quoteNo){
        return new Promise(resolve => {
            this.http.get(this.configService.getConfigBaseApiUrl() + `api/products/quote/${customerNo}/${quoteNo}`).subscribe(data => {
                resolve(data);
            }, error => resolve(this.HandleError(error))); 
        });         
    }

    HandleError(error) {
        if(error.status === 401){
            localStorage.clear();
            location.href = '/';
        }
        return error.errorMessage;
    }
}